import { Card, CardContent, Typography, Button, DialogContent, Dialog, DialogActions, List, ListItem, Grid, Chip, LinearProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { MPubCardSimple } from '../mPubCard';
import socketIOClient from "socket.io-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Countdown from 'react-countdown';
import EvidenceCreationPage from '../evidenceCreation.jsx';
import Round from './round';
import IncubatorAddCardTab from '../incubatorAddCardTab';
const AjaxFunctions = require('../../ajaxFunctions');
const SharedModels = require('../../../../../shared/sharedModels');
const moment = require('moment');
require('moment-timezone');
const SharedConstants = require('../../../../../shared/sharedConstants');
const ToastAlert = require('../../../client/components/toastAlert');

export default function Bracket(props) {
    let [bracketData, setBracketData] = useState();
    let [bracketMatchData, setBracketMatchData] = useState([]);
    let [voteData, setVoteData] = useState([]);
    let [votingContainerOpen, setVotingContainerOpen] = useState(false);
    let [missingVoteData, setMissingVoteData] = useState([]);

    let { portfolio, editMode, forceShowScore } = props;
    let idPortfolio = portfolio.id;
    let { idBracket, suggestionEndTime, items, idOwner, owners } = portfolio;
    let isSponsor = (idOwner == window.globals.idUser || owners.find(owner => owner.idUser == window.globals.idUser))

    useEffect(() => {
        /*
        const socket = socketIOClient(window.globals.socketConnection, { transports: ["websocket"] });
        socket.on(`UpdateBracketMatches${idBracket}`, async data => {
            setBracketMatchData(data)
        });
        socket.on(`UpdateBracket${idBracket}`, async data => {
            setBracketData(data)
        });
        return () => socket.disconnect();

         */
    }, []);

    useEffect(() => {
        const getBracketData = async () => {
            let bracketData = await AjaxFunctions.getBracketByID(idPortfolio, idBracket);
            let fullData = editMode ? 1 : 0
            let bracketMatchData = await AjaxFunctions.getBracketMatchesByID(idPortfolio, idBracket, fullData);
            try {
                let arpahData = await AjaxFunctions.getArpahSubmissionsForBracket(idBracket);
                for (let match of bracketMatchData) {
                    let arpahEntry = arpahData.find(x => x.idCard === match.idCard);
                    if (arpahEntry) {
                        match.arpahEntry = arpahEntry;
                    }
                }
            }
            catch (e){
                console.log(e);
            }
            try {
                let mpubs = await AjaxFunctions.getIncubatorMicroPubs(idPortfolio);
                for (let match of bracketMatchData) {
                    let card = mpubs.find(x => x.id === match.idCard && x.cardType === match.cardType);
                    if (card) {
                        match.comments = card.comments;
                    }
                }
            }
            catch (e){
                console.log(e);
            }


            setBracketData(bracketData);
            setBracketMatchData(bracketMatchData);
        }
        getBracketData();

    }, [idBracket]);

    let getAllVoteData = async () => {
        let {votes, missingVotes} = await AjaxFunctions.getUserBracketVotesWithMissing(bracketData.idBracket, portfolio.id);


        for(let match of Object.values(missingVotes)){
            if(match[0])
                match[0].arpahEntry = bracketMatchData.find(x => x.idCard === match[0].idCard)?.arpahEntry;
            if(match[1])
                match[1].arpahEntry = bracketMatchData.find(x => x.idCard === match[1].idCard)?.arpahEntry;
        }

        for(let match of Object.values(votes)){
            if(match)
                match.arpahEntry = bracketMatchData.find(x => x.idCard === match.idCard)?.arpahEntry;
        }

        setMissingVoteData(missingVotes);
        setVoteData(votes);
    }

    if (!bracketData) {
        return (
            <Card>
                <CardContent>
                    <LinearProgress />
                </CardContent>
            </Card>
        )
    }
    let contributedUserItems =
       items.filter(item =>
          (
             (
                item.cardType === bracketData.cardType) && (item.idSubmitter == window.globals.idUser)
                && (bracketMatchData.find(bracketItem => bracketItem.idCard == item.id)
             )
          )
       );
    let bracketStarted = suggestionEndTime ? moment(suggestionEndTime.toString().slice(0,10)).utcOffset("-05:00", true).endOf('day').isBefore(new Date()) : false;
    let currentRoundDate = bracketData[`round${bracketData.currentRound}EndTime`];
    let addCardComponent = <IncubatorAddCardTab 
    cardTypes={[{value:bracketData.cardType,label:(bracketData.cardType == SharedConstants.CardType.Reasoning) ? 'Conjecture' : 'Evidence'}]}
    cardFilter={cards => cards.filter(c => c.cardType == bracketData.cardType)}
     addCardFunction={props.addCardFunction}
        tab={props.tab} getUpdatedPortfolioData={props.getUpdatedPortfolioData}/>
    return (
        <Card className={'bracket-page'}>
            <CardContent className={'bracket-page-content'}>
                <div>
                    <Typography variant="h5" component="h2" color='primary' className='incubator-card-name'>
                        {`POLYPLEXUS MADNESS ${editMode ? `EDITOR` : ''} ${bracketData.title ? `: ${bracketData.title}` : ''}`}
                    </Typography>
                    <Typography className='incubator-card-name' gutterBottom>
                        {`${bracketData.subTitle ? bracketData.subTitle : ''}`}
                    </Typography>
                    <hr />
                    {((!bracketStarted && !editMode)) && <CountdownContainer time={suggestionEndTime} isSubmissionPeriod/>}
                    {
                        (!bracketStarted && !editMode && (isSponsor || contributedUserItems.length == 0)) &&
                        <AddCardsContainer
                           createCardFunction={props.createCardFunction}
                           addCardComponent={addCardComponent}
                           bracketData={bracketData}
                        />
                    }
                    {
                        (bracketData.currentRound <= 6 && (bracketStarted) && !editMode) && !bracketData.votingSuspended &&
                       <VotingContainer
                          getVoteData={() => getAllVoteData()}
                          voteData={missingVoteData}
                          open={votingContainerOpen}
                          setOpen={(val) => setVotingContainerOpen(val)}
                          bracketData={bracketData}
                          bracketMatchData={bracketMatchData}
                          idPortfolio={idPortfolio}
                          portfolio={portfolio}
                       />
                    }
                    {
                        !editMode && !bracketData.votingSuspended &&
                       <DeleteVotesContainer
                          getVoteData={() => getAllVoteData()}
                          userVotes={voteData}
                          bracketData={bracketData}
                          bracketMatchData={bracketMatchData}
                          idPortfolio={idPortfolio}
                          portfolio={portfolio}
                       />
                    }
                    {bracketStarted && <TotalVotesContainer bracketData={bracketData} bracketMatchData={bracketMatchData} />}
                    {(bracketStarted) && <CountdownContainer time={currentRoundDate} currentRound={bracketData.currentRound} />}
                    <BracketContainer
                       bracketStarted={bracketStarted}
                       bracketMatchData={bracketMatchData}
                       bracketData={bracketData}
                       contributedUserItems={contributedUserItems}
                       idPortfolio={idPortfolio}
                       editMode={editMode}
                       forceShowScore={forceShowScore}
                       onBackButton={() => props.onBackButton()}
                    />
                </div>
            </CardContent>
            <div className={'bracket-page-content-after'}>
                Mobile devices are not supported for this page. Please check back on a non-mobile device.
            </div>
        </Card>
    );
};

function TotalVotesContainer(props) {
    let { bracketData, bracketMatchData, } = props;
    let voteCount = bracketMatchData.filter(b => b.idRound == bracketData.currentRound).reduce((a, b) => a + b.score, 0);
    let totalVotes = parseInt(voteCount) + parseInt(bracketData.voteFudgeFactor);
    return (<div>
        <Chip style={{ width: '200px', marginBottom: '1em' }} label={`Total Votes: ${totalVotes ? totalVotes : '0'}`} variant="outlined"></Chip>
    </div>)
}
function CountdownContainer(props) {
    let { time, isSubmissionPeriod, currentRound } = props;
    if (currentRound == 5) currentRound = "Semifinals"
    else if (currentRound == 6) currentRound = "Finals"
    else currentRound = currentRound ? `Round ${currentRound}` : 'Round'
    
    let title = isSubmissionPeriod ? "Submission Period" : currentRound;
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        return completed ? <span>{`${title} Has Ended.`}</span> :
            <span>{title} Ends In: {days} {`day${days == 1 ? '' : 's'}`}, {hours} hours, {minutes} minutes, and {seconds} seconds.</span>
    };
    let formattedTime = time ? moment(time.toString().slice(0, 10)).utcOffset("-05:00", true).endOf('day') : null;
    return (time ? <Typography style={{ textAlign: 'center' }}>
        <Countdown date={formattedTime.toDate()} renderer={renderer} />
    </Typography> : <Typography style={{ textAlign: 'center' }}>{currentRound > 6?`${title} Has Not Been Provided.`:'Madness Tournament Has Ended.'}</Typography>)
}
function bracketCategory(idCategory) {
    switch (idCategory) {
        case SharedConstants.BracketCategory.TopLeftBracket.id:
            return { className: "topLeftBracket", name: SharedConstants.BracketCategory.TopLeftBracket.name };
        case SharedConstants.BracketCategory.BottomLeftBracket.id:
            return { className: "bottomLeftBracket", name: SharedConstants.BracketCategory.BottomLeftBracket.name };
        case SharedConstants.BracketCategory.TopRightBracket.id:
            return { className: "topRightBracket", name: SharedConstants.BracketCategory.TopRightBracket.name };
        case SharedConstants.BracketCategory.BottomRightBracket.id:
            return { className: "bottomRightBracket", name: SharedConstants.BracketCategory.BottomRightBracket.name };
    }
}

function DeleteVotesContainer(props) {
    let { bracketData, userVotes } = props;
    let [open, setOpen] = useState(false);
    const getBracketVotesForUser = async () => {
        await props.getVoteData();

        if (userVotes.length === 0) {
            setOpen(false)
        }
    }

    useEffect(() => {
        if (userVotes.length === 0) {
            setOpen(false)
        }
    }, [props.userVotes]);

    useEffect(() => {
        getBracketVotesForUser();
    }, [props.bracketData, props.bracketMatchData]);

    let deleteUserVote = async (idBracketMatch) => {
        try {
            await AjaxFunctions.deleteVoteFromBracket(idBracketMatch, props.idPortfolio, bracketData.idBracket);
            ToastAlert.success("Vote Deleted!");
            getBracketVotesForUser();
        } catch (err) {
            console.log(err)
            ToastAlert.error("Error Deleting Vote.")
        }
    }
    return (
        <React.Fragment>
            {userVotes.length > 0 &&
                <div className={'delete-votes-container'}>
                    <Button className="material-button" style={{ textTransform: 'none', width: '200px', marginBottom: '10px' }}
                        variant='outlined' color="primary" onClick={() => setOpen(true)}>Edit Votes</Button>
                    <Dialog
                       open={open}
                       maxWidth="md"
                       PaperProps={{
                           className: `delete-votes-dialog ${props.portfolio.name.replaceAll(" ","-")} ${props.portfolio.extraCssClass} `
                       }}
                    >
                        <DialogContent>
                            <Typography variant="h5" component="h2" color='primary'>
                                Your Votes: Round {bracketData.currentRound}
                            </Typography>
                            <Typography className='incubator-card-name' gutterBottom>
                                Click the delete button to remove your vote.
                            </Typography>
                            <List>
                                {userVotes.map(userVote => {
                                    let formattedCard = SharedModels.formatGenericCard(userVote);
                                    return (<ListItem key={`editVote_${userVote.id}`}>
                                        <Grid item xs={3}>
                                            <Chip
                                               label={bracketData['categoryTitle' + userVote.idCategory] || bracketCategory(userVote.idCategory).name}
                                               className={bracketCategory(userVote.idCategory).className}
                                               style={{ marginBottom: '10px', width: '100%' }}
                                            />
                                            <Button
                                               className="material-button"
                                               fullWidth onClick={() => deleteUserVote(userVote.idBracketMatch)}
                                               variant="outlined"
                                            >
                                                DELETE VOTE
                                            </Button>
                                        </Grid>
                                        <Grid item xs={9} style={{ marginLeft: '1em' }}>
                                            <MPubCardSimple initialTab="madness" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                                        </Grid>
                                    </ListItem>)
                                })}
                            </List>
                        </DialogContent>
                        <DialogActions>
                            <Button
                               className="material-button delete-vote-close-button"
                               onClick={() => setOpen(false)}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            }
        </React.Fragment>
    )
}
function VotingContainer(props) {
    let { bracketData, voteData } = props;
    let [currentItemIndex, setCurrentItemIndex] = useState(0)
    let [idBracketMatch, setIDBracketMatch] = useState(null);

    const getMissingBracketVotesForUser = async () => {
        await props.getVoteData();
    }

    useEffect(() => {
        getMissingBracketVotesForUser();
    }, [props.bracketData, props.bracketMatchData]);

    let addVoteToBracket = async () => {
        try {
            await AjaxFunctions.addVoteToBracket(idBracketMatch, props.idPortfolio, bracketData.idBracket);
            setIDBracketMatch(null);
            await getMissingBracketVotesForUser();
            ToastAlert.success("Vote Submitted!")
        } catch (err) {
            console.log(err)
            ToastAlert.error("Error Submitting Vote.")
        }
    }

    let VotingComponent = (votingProps) => {
        let { currentMatch } = votingProps;
        if (!currentMatch) {
            props.setOpen(false)
            return (<div />)
        }
        return (
            <div>
                <List>
                    {currentMatch.map(c => {
                        let formattedCard = SharedModels.formatGenericCard(c);
                        return (<ListItem key={`editVote_${c.id}`}>
                            <Grid item xs={2}>
                                <Chip
                                   label={bracketData['categoryTitle' + c.idCategory] || bracketCategory(c.idCategory).name}
                                   className={bracketCategory(c.idCategory).className}
                                   style={{ marginBottom: '10px', width: '100%' }}
                                />
                                <Button
                                   color="primary"
                                   style={{ textTransform: 'none' }}
                                   onClick={() => setIDBracketMatch(c.idBracketMatch)}
                                   fullWidth
                                   variant={idBracketMatch == c.idBracketMatch ? 'contained' : 'outlined'}
                                >
                                    Select
                                </Button>
                            </Grid>
                            <Grid item xs={10} style={{ marginLeft: '1em' }}>
                                <MPubCardSimple initialTab="madness" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                            </Grid>
                        </ListItem>)
                    })}
                </List>
            </div>
        );
    }
    return (
       <div className={'voting-container'}>
        {
            (Object.keys(voteData).length > 0 && Object.keys(voteData)[currentItemIndex]) &&
           <Button
              className="material-button voting-container-open-button"
              variant='outlined'
              color="primary"
              style={{ textTransform: 'none', width: '200px', marginBottom: '10px'}}
              color="secondary"
              onClick={() => props.setOpen(true)}
           >
               VOTE
           </Button>
        }
        <Dialog
           open={props.open}
           maxWidth="md"
           fullWidth
           PaperProps={{className: 'voting-container-dialog ' + props.portfolio.name.replaceAll(" ","-")}}

        >
            <DialogContent>
                <VotingComponent currentMatch={Object.values(voteData)[currentItemIndex]} />
            </DialogContent>
            <DialogActions>
                <Button
                   disabled={idBracketMatch == null}
                   className="material-button voting-dialog-vote"
                   onClick={() => addVoteToBracket()}
                >
                    Vote
                </Button>
                <Button className="material-button" onClick={() => {
                    let nextItem = Object.keys(voteData)[currentItemIndex + 1];
                    if (!nextItem) {
                        props.setOpen(false);
                    }
                    setCurrentItemIndex(nextItem ? currentItemIndex + 1 : 0);
                }}>Skip</Button>
                <Button className="material-button voting-dialog-close" onClick={() => props.setOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </div>)
}

function BracketContainer(props) {
    let { bracketData, bracketMatchData, contributedUserItems, bracketStarted, editMode, forceShowScore } = props;
    let visibleBracketMatchData = (!bracketStarted && !editMode) ? [] : bracketMatchData;    
    let isCurrentRound = (round) => {
        return bracketData.currentRound >= 7 ? "current" : (round == bracketData.currentRound || !bracketStarted) ? "current" : ""
    }
    const cardType = (props.bracketData.cardType == SharedConstants.CardType.Reasoning) ? 'Conjecture' : 'Evidence';

    return (
        <div id={'bracketContainer'}>
            {(!bracketStarted && !editMode) &&
                <div id={'bracketContributionStatus'}>
                    {
                        contributedUserItems.length == 0 &&
                       <Typography color="primary" variant="h6" style={{ textAlign: 'center' }}>
                           {`You Haven’t Submitted a µPub. Time is running out!`}
                       </Typography>
                    }
                    {
                        contributedUserItems.length > 0 &&
                       <Typography color="primary" variant="h6" style={{ textAlign: 'center' }}>
                           {`Your Submitted ${cardType}`}
                       </Typography>
                    }
                    <List>
                        {contributedUserItems.map(item => {
                            let bracketItem = bracketMatchData.find(
                               bracketItem => (bracketItem.idCard == item.id && bracketItem.cardType == item.cardType)
                            )
                            let formattedCard = SharedModels.formatGenericCard(bracketItem);
                            return (
                               <ListItem key={`displayCard_${bracketItem.id}`}>
                                <div>
                                    <Chip
                                       label={bracketCategory(bracketItem.idCategory).name}
                                       className={bracketCategory(bracketItem.idCategory).className}
                                       style={{ marginBottom: '10px', width: '150px', marginRight: '1em' }}
                                    />
                                </div>
                                <MPubCardSimple initialTab="madness" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                                </ListItem>
                            )
                        })}
                    </List>
                    <hr/>
                </div>
            }
            <div className={'back-button'} onClick={() => props.onBackButton()}>

            </div>
            <div style={{ marginTop: '1em' }} className="bracket-category-chip">
                <Chip
                   label={bracketData.categoryTitle0 || SharedConstants.BracketCategory.TopLeftBracket.name}
                   className="topLeftBracket"
                />
                <Chip
                   label={bracketData.categoryTitle2 || SharedConstants.BracketCategory.TopRightBracket.name}
                   className="topRightBracket"
                   style={{ float: 'right' }}
                />
            </div>
            <section className="bracket">
                <div id="bracket-container">
                    <div className="split split-one">
                        <Round className={`round round-one ${isCurrentRound(1)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 1" idRound="1" side="left" numMatches="32" topClass="topLeftBracket" bottomClass="bottomLeftBracket" editMode={(editMode && bracketData.currentRound == 1)} disableLink={editMode} forceShowScore={forceShowScore} />
                        <Round className={`round round-two ${isCurrentRound(2)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 2" idRound="2" side="left" numMatches="16" topClass="topLeftBracket" bottomClass="bottomLeftBracket" disableLink={editMode} forceShowScore={forceShowScore} />
                        <Round className={`round round-three ${isCurrentRound(3)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 3" idRound="3" side="left" numMatches="8" topClass="topLeftBracket" bottomClass="bottomLeftBracket" disableLink={editMode} forceShowScore={forceShowScore} />
                        <Round className={`round round-four ${isCurrentRound(4)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 4" idRound="4" side="left" numMatches="4" topClass="topLeftBracket" bottomClass="bottomLeftBracket" disableLink={editMode} forceShowScore={forceShowScore} />
                    </div>
                    <div className="champion">
                        <Round isChampionship className={`semis-l ${isCurrentRound(5)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Semifinals: Left" idRound="5" side="left" numMatches="2" topClass="topLeftBracket" bottomClass="bottomLeftBracket" disableLink={editMode} forceShowScore={forceShowScore} />
                        <div className={`final ${isCurrentRound(6)}`}>
                            <FontAwesomeIcon icon={[`fa`, 'trophy']} size="4x" color="lightgrey" />
                            <Round isChampionship isFinal matchData={visibleBracketMatchData} bracketData={bracketData} title="Finals" numMatches="2" idRound="6" disableLink={editMode} forceShowScore={forceShowScore} />
                        </div>
                        <Round isChampionship className={`semis-r ${isCurrentRound(5)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Semifinals: Right" idRound="5" side="right" numMatches="2" topClass="topRightBracket" bottomClass="bottomRightBracket" disableLink={editMode} forceShowScore={forceShowScore} />
                    </div>
                    <div className="split split-two">
                        <Round className={`round round-four ${isCurrentRound(4)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 4" idRound="4" side="right" numMatches="4" topClass="topRightBracket" bottomClass="bottomRightBracket" disableLink={editMode} forceShowScore={forceShowScore}/>
                        <Round className={`round round-three ${isCurrentRound(3)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 3" idRound="3" side="right" numMatches="8" topClass="topRightBracket" bottomClass="bottomRightBracket" disableLink={editMode} forceShowScore={forceShowScore}/>
                        <Round className={`round round-two ${isCurrentRound(2)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 2" idRound="2" side="right" numMatches="16" topClass="topRightBracket" bottomClass="bottomRightBracket" disableLink={editMode} forceShowScore={forceShowScore}/>
                        <Round className={`round round-one ${isCurrentRound(1)}`} matchData={visibleBracketMatchData} bracketData={bracketData} title="Round 1" idRound="1" side="right" numMatches="32" topClass="topRightBracket" bottomClass="bottomRightBracket" editMode={(editMode && bracketData.currentRound == 1)} disableLink={editMode} forceShowScore={forceShowScore}/>
                    </div>
                </div>
                <div style={{ marginTop: '1em' }} className="bracket-category-chip">
                    <Chip
                       label={bracketData.categoryTitle1 || SharedConstants.BracketCategory.BottomLeftBracket.name}
                       className="bottomLeftBracket"
                    />
                    <Chip
                       label={bracketData.categoryTitle3 || SharedConstants.BracketCategory.BottomRightBracket.name}
                       className="bottomRightBracket"
                       style={{ float: 'right' }}
                    />
                </div>
            </section>
        </div>
    )
}

function AddCardsContainer(props) {
    let [addCardOpen, setAddCardOpen] = useState(false);
    let [createCardOpen, setCreateCardOpen] = useState(false);
    const cardType = (props.bracketData.cardType == SharedConstants.CardType.Reasoning) ? 'CONJECTURE' : 'EVIDENCE';
    return (<div>
        <div style={{ textAlign: 'center' }} className={'add-cards-container'}>
            {
                props.addCardComponent &&
               <Button
                  className="material-button"
                  variant='outlined'
                  style={{ textTransform: 'none' }}
                  onClick={() => setAddCardOpen(true)}
               >
                   ADD EXISTING {cardType}
               </Button>
            }
            {
                (props.createCardFunction && props.bracketData.cardType == SharedConstants.CardType.Evidence) &&
               <Button
                  className="material-button"
                  variant='outlined'
                  style={{ textTransform: 'none', marginLeft: '1em' }}
                  onClick={() => setCreateCardOpen(true)}
               >
                   ADD NEW {cardType}
               </Button>
            }
        </div>
        <hr />
        <Dialog open={addCardOpen} maxWidth="lg" fullWidth>
            <DialogContent>
                {props.addCardComponent}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setAddCardOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={createCardOpen} maxWidth="lg" fullWidth>
            <DialogContent>
                <EvidenceCreationPage
                    onCreate={(idCard) => {
                        setCreateCardOpen(false);
                        props.createCardFunction(idCard);
                    }}
                    hideAddToIncubator
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setCreateCardOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </div>)
}